/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconClockShare = createReactComponent("outline", "clock-share", "IconClockShare", [["path", { "d": "M20.943 13.016a9 9 0 1 0 -8.915 7.984", "key": "svg-0" }], ["path", { "d": "M16 22l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-2" }], ["path", { "d": "M12 7v5l2 2", "key": "svg-3" }]]);

export { IconClockShare as default };
//# sourceMappingURL=IconClockShare.mjs.map
